var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "2.22rem",
    width: "2.22rem",
    viewBox: "0 0 29.72 28.49",
    alt: "Download file",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.82,22.58a.28.28,0,0,0,.17.07.24.24,0,0,0,.17-.07l8.35-8.35a.27.27,0,0,0,0-.26.25.25,0,0,0-.22-.15H18.71V.24A.24.24,0,0,0,18.47,0H11.52a.24.24,0,0,0-.24.24V13.82H6.65a.24.24,0,0,0-.17.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 25.96,
    width: 29.72,
    height: 2.53,
    rx: 0.24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.f5e45eae.svg";
export { ForwardRef as ReactComponent };